export const getUrlParameter = (name: string): string => {
  const url = window.location.search
  const params = new URLSearchParams(url)
  const param = params.get(name)
  return param ?? ""
}
